import { ref, serverTimestamp, set } from 'firebase/database';
import { database } from '../auth/firebase';

export const sendMessage = ({ message, sender, receiver }) => {
    const timeID = Date.now();

    set(ref(database, `chat/messages/${timeID}`), {
        message: message,
        senderUsername: sender,
        recieverUsername: receiver,
        localTimestamp: timeID,
        serverTimestamp: serverTimestamp(),
    });

    set(ref(database, `chat/list/${receiver}/${sender}`), {
        chatterUsername: sender,
        lastMessage: message,
        serverTimestamp: serverTimestamp(),
    });

    set(ref(database, `chat/list/${sender}/${receiver}`), {
        chatterUsername: receiver,
        lastMessage: message,
        serverTimestamp: serverTimestamp(),
    });
};
